import type { OnboardingStatus } from '../../lib/types';
import type { ChannelsValue } from './ChannelsSection';
import type { SectionNavItem } from './SectionNav';
import type { SectionStatus } from './types';

export type EditSectionId = 'identidad' | 'canales' | 'integracion' | 'conocimiento' | 'modo';

const EDIT_SECTION_LABELS: Record<EditSectionId, string> = {
  identidad: 'Identidad',
  canales: 'Canales',
  integracion: 'Integración',
  conocimiento: 'Conocimiento',
  modo: 'Modo del bot',
};

export const EDIT_SECTION_IDS: EditSectionId[] = [
  'identidad',
  'canales',
  'integracion',
  'conocimiento',
  'modo',
];

/**
 * Traduce el onboarding-status del backend (lo único que la API expone hoy
 * sobre la config de un tenant) al estado que muestran las tabs.
 */
export function channelsValueFromStatus(status: OnboardingStatus | null): ChannelsValue {
  const telegram = status?.channels?.telegram;
  const whatsapp = status?.channels?.whatsapp;
  return {
    telegram: {
      tokenUploaded: telegram === 'done' || telegram === 'token-only',
      webhookRegistered: telegram === 'done',
    },
    whatsapp: {
      secretsUploaded: whatsapp === 'done',
      webhookRegistered: whatsapp === 'done',
    },
  };
}

export function editSectionStatuses(
  status: OnboardingStatus | null,
): Record<EditSectionId, SectionStatus> {
  const telegram = status?.channels?.telegram;
  const whatsapp = status?.channels?.whatsapp;

  let canales: SectionStatus = 'empty';
  if (telegram === 'done' || whatsapp === 'done') canales = 'complete';
  else if (telegram === 'token-only') canales = 'partial';

  let conocimiento: SectionStatus = 'unknown';
  if (status?.kb === 'synced') conocimiento = 'complete';
  else if (status?.kb === 'unsynced') conocimiento = 'partial';
  else if (status?.kb === 'missing') conocimiento = 'empty';

  return {
    identidad: 'complete',
    canales,
    integracion: status?.erp === 'done' ? 'complete' : 'empty',
    conocimiento,
    // La API no devuelve el modo guardado: no podemos afirmar nada.
    modo: 'unknown',
  };
}

export function editNavItems(status: OnboardingStatus | null): SectionNavItem[] {
  const statuses = editSectionStatuses(status);
  return EDIT_SECTION_IDS.map((id) => ({
    id,
    label: EDIT_SECTION_LABELS[id],
    status: statuses[id],
  }));
}
